import gql from 'graphql-tag';

export const PremiumTrialDetailsQuery = gql`
	query PremiumTrialDetailsQuery($startTime: String!) {
		license {
			billingSourceSystem
			licenseConsumingUserCount
			trialEndDate
		}
		premiumFeaturesUserCount: instanceAnalyticsCount(
			startTime: $startTime
			eventName: [
				analyticsPageModal_viewed
				pageAnalytics_viewed
				spaceAnalytics_viewed
				instanceAnalytics_viewed
				teamCalendars_viewed
				calendar_created
				automationRuleTrack_created
				inspectPermissionsDialog_viewed
			]
		) {
			user
		}
	}
`;
